import React from 'react';

interface IconProps {
  width?: string;
}

const TED = ({ width = '75' }: IconProps): JSX.Element => (
  <svg
    width={width}
    className='ted'
    viewBox='0 0 75 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='TED'>
      <path
        d='M7.59519 7.02786H0V0.107178H23.5451V7.02786H15.9499V27.1072H7.59519V7.02786Z'
        fill='white'
      />
      <path
        d='M24.8077 0.107178H47.6672V7.01804L33.1624 7.02786V10.3433H47.6672V16.7875L33.1624 16.7777V20.1865H47.6672V27.1072H24.8077V0.107178Z'
        fill='white'
      />
      <path
        d='M49.0629 0.107178H62.7737C71.809 0.107178 75 6.76263 75 13.5703C75 21.8516 70.5958 27.1072 61.1412 27.1072H49.0679V0.107178H49.0629ZM57.4176 20.1865H60.6826C65.8858 20.1865 66.6453 15.9869 66.6453 13.4525C66.6453 11.753 66.1126 7.02295 60.0759 7.02295H57.4176V20.1865Z'
        fill='white'
      />
    </g>
  </svg>
);

export default TED;
